import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RTButton from '../common/RTButton';
import '../common/rtCommon.css';
import RTPageLayout from '../common/RTPageLayout';

const ViewRentalInvoiceStatus = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <RTPageLayout
      activePath={location.pathname}
      title="View Rental Invoice Status"
      actions={
        <>
          <RTButton variant="secondary" onClick={() => navigate(-1)}>
            &#8592; Back
          </RTButton>
        </>
      }
      mainSection={true}
    >
      {/* Main content goes here */}
    </RTPageLayout>
  );
};

export default ViewRentalInvoiceStatus;
